import {NavigateFunction, NavigateOptions, useNavigate} from "react-router";
import {useEffect} from "react";

let globalNavigate: NavigateFunction | null = null;

export const GlobalNavigate = () => {
	const navigate = useNavigate();
	useEffect(() => {
		globalNavigate = navigate;
	}, [navigate]);
	return null;
};

export function navigate(to: string, options?: NavigateOptions) {
	if (globalNavigate) {
		globalNavigate(to, options);
	} else {
		console.error(`global navigation is not available. it will not be possible to navigate to ${to}`);
	}
}